import { selector } from 'recoil';
import { userAccountAtom } from '../atoms/account_atoms';

export const canManageDevicesSelector = selector({
  key: 'canManageDevices',
  get: ({ get }) => {
    const user = get(userAccountAtom);
    return Boolean(user?.permissions.manage_devices);
  },
});
